import { IOrderLineDtoForRegisterDelivery } from 'gen/ApiClient';
import { IRegisterOrderDeliveryLineModel } from './IRegisterOrderDeliveryLineModel';

export const mapToRegisterOrderLineModel = (line: IOrderLineDtoForRegisterDelivery): IRegisterOrderDeliveryLineModel => {
	return {
		id: line.data.id,
		isSelected: true,
		orderLine: line.data,
		serialNumber: undefined,
		quantity: line.data.quantity,
		productCatalogItem: line.productCatalogItem,
		autoGenerateSerialNumber: false,
		inventoryItem: line.inventoryItem,
	};
};
